import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type FleekFunctionDeploymentNotFoundErrorOptions = {
  deployment?: ObjectId;
};

export class FleekFunctionDeploymentNotFoundError extends FleekError<FleekFunctionDeploymentNotFoundErrorOptions> {
  public name = 'FleekFunctionDeploymentNotFoundError';

  toString = () => {
    return `Deployment not found.`;
  };
}
